<template>
  <el-dialog
    :title="(item.ID ? '' : '新增') + '产品型号'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    :close-on-click-modal="!visible"
  >
    <div class="border-style">基本信息</div>
    <el-form :model="item" ref="itemform" label-width="120px" :rules="rules">
      <el-form-item label="产品型号名称" prop="Name">
        <el-input
          v-model.trim="item.Name"
          placeholder="请输入名称"
          :disabled="isDetail"
        ></el-input>
      </el-form-item>
      <el-form-item label="产品型号" prop="Number">
        <el-input
          v-model.trim="item.Number"
          placeholder="请输入型号"
          :disabled="isDetail"
        ></el-input>
      </el-form-item>
      <el-form-item label="产品SN代码" prop="SNCode">
        <el-input
          v-model.trim="item.SNCode"
          placeholder="请输入SN代码"
          :disabled="isDetail"
        ></el-input>
      </el-form-item>
      <el-form-item label="说明" prop="Remark">
        <el-input
          v-model.trim="item.Remark"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入说明"
          :disabled="isDetail"
        >
        </el-input>
      </el-form-item>
    </el-form>

    <div class="border-style">相关配件型号</div>
    <div class="toolbar">
      <el-button type="primary" size="mini" @click="onCreateItem()" v-if="!isDetail">
        <i class="fas fa-plus"></i> 选择配件型号
      </el-button>
    </div>
    <el-table :data="acList">
      <el-table-column prop="Name" label="配件名称" />
      <el-table-column prop="Brand" label="品牌" />
      <el-table-column prop="ModelNumber" label="型号" />
      <el-table-column width="80" label="操作" v-if="!isDetail">
        <template slot-scope="scope">
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 关 闭
      </el-button>
      <el-button
        type="primary"
        @click="onSubmit"
        :disabled="submitting"
        v-if="!isDetail"
      >
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>

    <choose-accessory
      v-model="item"
      :visible.sync="accvisible"
      @form:saved="updateAccList"
    />
  </el-dialog>
</template>

<script>
import ChooseAccessory from "./chooseAccessory.vue";
export default {
  components: {
    ChooseAccessory,
  },
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      rules: {
        Name: [{ required: true, message: "名称不能为空", trigger: "blur" }],
        Number: [{ required: true, message: "型号不能为空", trigger: "blur" }],
        SNCode: [{ required: true, message: "SN不能为空", trigger: "blur" }],
        Remark: [{ max: 64000, message: "内容过多", trigger: "blur" }],
      },
      submitting: false,
      acList: [],
      accvisible: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
    isDetail() {
      if (this.item.ID) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onOpen() {
      this.visible = true;
      this.item = _.cloneDeep(this.value);
      this.acList = this.item.IpcAccessoryModels;
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
      this.acList = [];
    },
    onCreateItem() {
      this.accvisible = true;
    },
    updateAccList(list) {
      var arr = this.acList;
      var ids = [];
      //去重
      for (let i in arr) {
        ids.push(arr[i].ID);
      }
      for (let i in list) {
        if (ids.indexOf(list[i].ID) == -1) {
          ids.push(list[i].ID);
          arr.push(list[i]);
        }
      }
      this.acList = arr;
    },
    onDeleteItem(row) {
      for (let i in this.acList) {
        if (this.acList[i].ID == row.ID) {
          this.acList.splice(i, 1);
          break;
        }
      }
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.item);

        var ids = [];
        for (let i in this.acList) {
          ids.push(this.acList[i].ID);
        }
        this.item.IpcAccessoryModelIDs = ids;
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios
          .request({
            url: "ipc/model/product",
            method: "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success("新增成功");
            this.submitting = false;
            this.$emit("form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit("form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },
  },
};
</script>
<style scoped>
.el-divider--horizontal {
  margin: 0px 0 12px 0;
}
.border-style {
  height: 28px;
  line-height: 28px;
  border-radius: 0 15px 15px 0;
  border-left: 3px solid #409eff;
  padding-left: 5px;
  margin-bottom: 10px;
  background-color: #ecf5ff;
  color: #409eff;
  font-size: 13px;
  font-weight: bolder;
}
</style>
